export const PHONE_VERIFICATION_MESSAGE_CODES = {
	error: {
		tokenUsed: "E_TOKEN_USED",
		alreadyVerified: "E_ALREADY_VERIFIED",
		tokenNotFound: "E_TOKEN_NOT_FOUND",
	},
	success: {
		requestCodeSuccess: "M_REQUEST_CODE_SUCCESS",
		verifyCodeSuccess: "M_VERIFY_CODE_SUCCESS",
	},
};
